import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en-GB';
import { registerLocaleData } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { SinglePaymentComponent } from './containers/single-payment/single-payment.component';
import { ResultComponent } from './containers/result/result.component';
import { HeaderComponent } from './components/header/header.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { SuccessAnimationComponent } from './components/success-animation/success-animation.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PendingComponent } from './containers/pending/pending.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorComponent } from './containers/error/error.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { FooterComponent } from './components/footer/footer.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { CookieSnackbarComponent } from './components/cookie-snackbar/cookie-snackbar.component';
import { CancelledComponent } from './containers/cancelled/cancelled.component';
import { CancelledPaidComponent } from './containers/cancelled-paid/cancelled-paid.component';
import { MatTabsModule } from '@angular/material/tabs';
import { PaymentTypeToggleComponent } from './components/payment-type-toggle/payment-type-toggle.component';
import { MatRippleModule } from '@angular/material/core';
import { ValuePropositionComponent } from './components/value-proposition/value-proposition.component';
import { SummaryComponent } from './components/summary/summary.component';
import { BalanceInfoComponent } from './components/balance-info/balance-info.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { LiabilityInfoComponent } from './components/liability-info/liability-info.component';
import { FloatingSubmitComponent } from './components/floating-submit/floating-submit.component';
import { BillGatewayAppDialogComponent } from './components/bill-gateway-app-dialog/bill-gateway-app-dialog.component';
import { ChatComponent } from './components/chat/chat.component';
import { ValuePropositionVerticalComponent } from './components/value-proposition-vertical/value-proposition-vertical.component';
import { WireTransferComponent } from './containers/wire-transfer/wire-transfer.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TransferPaymentDialogComponent } from './components/transfer-payment-dialog/transfer-payment-dialog.component';
import { SubmitButtonComponent } from './components/submit-button/submit-button.component';
import { CardPaymentComponent } from './containers/card-form/card-payment.component';
import { MaintenanceComponent } from './containers/maintenance/maintenance.component';
import { IconComponent } from './components/icon/icon.component';

registerLocaleData(localeEn, 'en-GB');
registerLocaleData(localePl, 'pl-PL');

@NgModule({
  declarations: [
    AppComponent,
    SinglePaymentComponent,
    ResultComponent,
    HeaderComponent,
    PaymentMethodComponent,
    SuccessAnimationComponent,
    PendingComponent,
    ErrorComponent,
    FooterComponent,
    CookieSnackbarComponent,
    CancelledComponent,
    CancelledPaidComponent,
    PaymentTypeToggleComponent,
    ValuePropositionComponent,
    SummaryComponent,
    BalanceInfoComponent,
    LiabilityInfoComponent,
    FloatingSubmitComponent,
    BillGatewayAppDialogComponent,
    ChatComponent,
    ValuePropositionVerticalComponent,
    WireTransferComponent,
    TransferPaymentDialogComponent,
    SubmitButtonComponent,
    CardPaymentComponent,
    MaintenanceComponent,
    IconComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatIconModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTabsModule,
    MatRippleModule,
    MatTooltipModule,
    OverlayModule,
    ClipboardModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
